module.exports = require("npm:process@0.11.10/browser.js");